module.exports = __webpack_public_path__ + "img/mavis-at-the-skatepark.a39f290e.jpg";